/* esm.sh - react-remove-scroll@2.7.2/dist/es2015/handleScroll */
export * from "/*react-remove-scroll@2.7.2/esnext/dist/es2015/handleScroll.mjs";
